import Slider from './slider.element.js';

export default Slider;

Slider.define('wje-slider', Slider);
